'use client'

import { Box, Text, useMultiStyleConfig } from '@chakra-ui/react'
import { ContentfulAviosOnlyPromotionContent } from '@reward-platform/shared-schemas'
import React from 'react'
import { ArrowShape } from '~/components/search-and-results/FlightAviosOnlyBanner/ArrowShape'
import { BackgroundShape } from '~/components/search-and-results/FlightAviosOnlyBanner/BackgroundShape'
import { BannerMainContent } from '~/components/search-and-results/FlightAviosOnlyBanner/BannerMainContent'

type BannerProps = {
  aviosOnlyPromotionContent: ContentfulAviosOnlyPromotionContent
  aviosOnlySeatsAvailable: boolean
}

export function BannerContent({ aviosOnlyPromotionContent, aviosOnlySeatsAvailable }: BannerProps) {
  const { title, introduction } = aviosOnlyPromotionContent
  const styles = useMultiStyleConfig('FlightAviosOnlyBanner', {})

  return (
    <>
      <BackgroundShape />
      <Box sx={styles.promoBanner}>
        <Box sx={aviosOnlySeatsAvailable ? styles.content : styles.contentSoldOut}>
          <Box sx={styles.contentWrapper}>
            <ArrowShape color="#7FB600" />

            <Box sx={styles.promoTextWrapper}>
              <Text sx={styles.promoTitle}>
                <Text as="span" sx={styles.introText}>
                  {introduction}
                </Text>{' '}
                <Text as="span" sx={styles.titleText}>
                  {title}
                </Text>
              </Text>

              <Box sx={styles.mainText}>
                <BannerMainContent />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      {aviosOnlySeatsAvailable && <Text sx={styles.disclaimerText}>T&Cs apply.</Text>}
    </>
  )
}
